/* global google, Modernizr */

import $ from 'jquery'
import { formatNumber } from './helpers'
import { formatDate } from './datetime'
import { isMediaActive } from './viewport'
import { loadRailsPayload } from '../apps/@utils'

const debug = require('debug')('pm:stats')
debug('loaded')

const Stats = {
  areaChartOptions: {
    width: $('.area-chart').width(),
    height: 200,
    chartArea: {
      left: isMediaActive('m') ? 60 : 40,
      top: 6,
      right: isMediaActive('m') ? 30 : 0,
      width:
        $('.area-chart').width() -
        (isMediaActive('m') ? 60 : 40) -
        (isMediaActive('m') ? 30 : 0),
      height: 160,
    },
    lineWidth: 0,
    pointSize: 0,
    series: [],
    focusTarget: 'category',
    fontSize: isMediaActive('m') ? 11 : 9,
    fontName: 'Rund Text, Helvetica Neue, Arial',
    hAxis: {
      // Dates
      baselineColor: '#FFF',
      gridlines: {
        color: '#EEE',
      },
      minorGridlines: {
        color: '#FAFAFA',
        count: 6,
      },
      textStyle: {
        color: '#777',
      },
      allowContainerBoundaryTextCufoff: true,
      ticks: [],
    },
    vAxis: {
      // Numbers
      baselineColor: '#999',
      gridlines: {
        color: '#EEE',
        count: 4,
      },
      textStyle: {
        color: '#777',
      },
    },
    legend: {
      position: 'none',
    },
    enableInteractivity: !Modernizr.touchevents,
    tooltip: {
      isHtml: true,
      textStyle: {
        color: '#444',
      },
    },
  },

  timeChartOptions: {
    width: 268,
    height: 178,
    chartArea: {
      top: 10,
      right: 15,
      bottom: 30,
      left: 40,
      width: 213,
      height: 138,
    },
    lineWidth: 0,
    pointSize: 0,
    series: [
      {
        color: '#62CED7',
        areaOpacity: 0.45,
      },
    ],
    fontSize: 11,
    fontName: 'Rund Text, Helvetica Neue, Arial',
    hAxis: {
      showTextEvery: 4,
      baselineColor: '#FFF',
      gridlines: {
        color: '#FFF',
        count: 1,
      },
      textStyle: {
        color: '#777',
      },
      allowContainerBoundaryTextCufoff: true,
    },
    vAxis: {
      minValue: 0,
      maxValue: 1,
      format: '#%',
      baselineColor: '#FFF',
      gridlines: {
        color: '#F3F3F3',
        count: 5,
      },
      minorGridlines: null,
      textStyle: {
        color: '#777',
      },
      allowContainerBoundaryTextCufoff: true,
    },
    legend: {
      position: 'none',
    },
    tooltip: {
      trigger: 'none',
    },
  },

  clickedChartOptions: {
    backgroundColor: 'transparent',
    chartArea: {
      width: 145,
      height: 145,
    },
    pieHole: 0.93,
    legend: {
      position: 'none',
    },
    tooltip: {
      trigger: 'none',
    },
    enableInteractivity: false,
    slices: [{ color: '#B579D6' }, { color: '#E2E2E2' }],
    pieSliceTextStyle: {
      color: 'transparent',
    },
    pieSliceBorderColor: 'transparent',
  },

  optionsSeries: {
    sent: {
      color: '#DAF2CE',
      areaOpacity: 0.66,
    },
    opened: {
      color: '#67BBE5',
      areaOpacity: 0.3,
    },
    clicked: {
      color: '#DF9CFF',
      areaOpacity: 0.35,
    },
    bounced: {
      color: '#F2AD9F',
      areaOpacity: 1.0,
    },
    processed: {
      // == sent
      color: '#DAF2CE',
      areaOpacity: 0.66,
    },
    failed: {
      // == bounced
      color: '#F2AD9F',
      areaOpacity: 1.0,
    },
  },

  init: function () {
    debug('init')
    Stats.maybeLoadChart(
      '#stats-chart',
      Stats.drawAreaChart,
      Stats.areaChartOptions,
      'outbound'
    )
    Stats.maybeLoadChart(
      '#inbound-chart',
      Stats.drawAreaChart,
      Stats.areaChartOptions,
      'inbound'
    )
    Stats.maybeLoadChart(
      '.js-unique-click-chart',
      Stats.drawUniqueClickChart,
      Stats.clickedChartOptions
    )
  },

  maybeLoadChart: function (selector, callback, options, type) {
    const $el = $(selector)

    if (!$el.length) {
      return
    }

    // Don't load the same chart twice
    if ($el.data('chart-loaded')) {
      debug('chart already loaded!!', { selector })
      return
    }
    $el.data('chart-loaded', true)

    debug('maybeLoadChart()', { selector, type })

    const chartDataSelector = $el.data('chart-data')
    if (chartDataSelector) {
      const data = loadRailsPayload($(chartDataSelector).get(0))
      callback($el.get(0), data, options, type)
      $el.removeClass('u-is-loading')
    }
  },

  drawAreaChart: function (el, array, options, type) {
    // https://google-developers.appspot.com/chart/interactive/docs/gallery/areachart
    debug('drawAreaChart', { array, options, type })

    const hasOpens = array[0].length > 3
    const data = new google.visualization.DataTable()
    const chart = new google.visualization.AreaChart(el)

    Stats.originalData = array

    // Convert dates from Array to Date type

    $.each(array, function (index, value) {
      const date = new Date(value[0])
      const timeWithoutOffset =
        date.getTime() + date.getTimezoneOffset() * 60 * 1000

      value[0] = new Date()
      value[0].setTime(timeWithoutOffset)
      options.hAxis.ticks.push({
        v: value[0],
        f: formatDate(value[0], 'MMM D, yyyy'),
      })
    })

    // Prepare table structure

    data.addColumn('date', 'Date')

    if (type === 'outbound') {
      data.addColumn('number', 'Sent')
      options.series.push(Stats.optionsSeries.sent)

      if (hasOpens) {
        data.addColumn('number', 'Opened')
        options.series.push(Stats.optionsSeries.opened)
      }

      data.addColumn('number', 'Bounced')
      options.series.push(Stats.optionsSeries.bounced)
    }
    if (type === 'inbound') {
      data.addColumn('number', 'Processed')
      options.series.push(Stats.optionsSeries.processed)

      data.addColumn('number', 'Failed')
      options.series.push(Stats.optionsSeries.failed)
    }

    // Insert array
    data.addRows(array)

    // Draw chart
    chart.draw(data, options)

    // Enable hover state
    Stats.hoverAreaChart(el, data, chart, options, array.length)

    $(el).removeClass('u-is-loading')
  },

  isTimeChartEmpty: function (el, array, options) {
    let isExists = false

    $.each(array, function (i, el) {
      if (el[1] !== 0) {
        isExists = true
        return false
      }
    })

    if (isExists) {
      Stats.drawTimeChart(el, array, options)
    }
  },

  drawTimeChart: function (el, array, options) {
    // https://google-developers.appspot.com/chart/interactive/docs/gallery/areachart
    debug('drawTimeChart', { array, options })

    const data = new google.visualization.DataTable(),
      chart = new google.visualization.AreaChart(el)

    // Prepare table structure

    data.addColumn('string', 'Time')
    data.addColumn('number', 'Read time')

    // Insert array

    data.addRows(array)

    // Draw chart

    chart.draw(data, options)
  },

  hoverAreaChart: function (el, data, chart, options, numOfDays) {
    const hover = $(el).siblings('.area-chart-hover')
    const numOfBlocks = numOfDays - 1
    const hoverWidth = options.chartArea.width / numOfBlocks
    const leftMargin = options.chartArea.left
    const uri = $(el).data('activity-uri')
    let parsedURI

    function formatDate(date) {
      // Reformat date to MM/DD/YY

      let day = date.getDate(),
        month = date.getMonth() + 1,
        year = date.getFullYear()

      if (day.toString().length < 2) {
        day = '0' + day
      }
      if (month.toString().length < 2) {
        month = '0' + month
      }

      year = year.toString().substr(2, 2)

      return month + '/' + day + '/' + year
    }

    hover
      .height(options.chartArea.height)
      .css('top', options.chartArea.top)
      .bind('click.openActivity', function () {
        if (uri !== undefined) {
          window.location.href = parsedURI
        }
      })

    google.visualization.events.addListener(
      chart,
      'onmouseover',
      function (event) {
        const date = new Date(Stats.originalData[event.row][0])
        let _leftMargin

        // Reset sizes to default

        hover.width(hoverWidth)
        _leftMargin = leftMargin - hoverWidth / 2

        // First and last blocks are half-width

        if (event.row === 0) {
          hover.width(hoverWidth / 2)
          _leftMargin = leftMargin
        }
        if (event.row === numOfBlocks) {
          hover.width(hoverWidth / 2)
        }

        // Show hover bar

        hover.css('left', _leftMargin + event.row * hoverWidth)

        // Update link URI
        if (uri !== undefined) {
          parsedURI = uri.replace(
            /%date%/gi,
            encodeURIComponent(formatDate(date))
          )
        }
      }
    )

    google.visualization.events.addListener(chart, 'onmouseout', function () {
      hover.css('left', '-1000px')
    })
  },

  drawUniqueClickChart: function (el, data, options) {
    debug('drawUniqueClickChart', { data, options })

    const pieChartData = [
      ['Key', 'Value'],
      ['Clicked', data.clicked],
      ['Not clicked', data.not_clicked],
    ]

    const donut = new google.visualization.PieChart(el)
    donut.draw(google.visualization.arrayToDataTable(pieChartData), options)

    // Render legend and percentage
    Stats.renderUniqueClickPercentage(el, pieChartData)
    Stats.renderUniqueClickLegend(el, pieChartData)
  },

  renderUniqueClickLegend: function (el, data) {
    const clicked = formatNumber(data[1][1])
    const notClicked = formatNumber(data[2][1])

    const html = `
      <ul class="unique-click-chart_legend">
        <li><span class="unique-click-chart_color legend--clicked"></span>${clicked} Clicked</li>
        <li><span class="unique-click-chart_color legend--not-clicked"></span>${notClicked} Not clicked</li>
      </ul>
    `
    $(el).append(html)
  },

  renderUniqueClickPercentage: function (el, data) {
    const pc = Math.round((data[1][1] / (data[1][1] + data[2][1])) * 100)

    const html = `
      <div class="unique-click-chart_percent">
        ${pc}<span class="unique-click-chart_unit">%</span>
      </div>
    `

    $(el).append(html)
  },
}

document.addEventListener('DOMContentLoaded', () => {
  debug('DOMContentLoaded')

  if (document.querySelector('script[data-js-google-jsapi-load-stats]')) {
    if (typeof google === 'undefined') {
      throw new Error('"google jsapi" not found. Charts will not be loaded.')
    }

    google.setOnLoadCallback(function () {
      debug('google.setOnLoadCallback()')

      Stats.init()
    })
  }
})

// lazy load tags dropdown
$(document).one('click', '.js-toolbar-dropdown-tags', function () {
  const $el = $(this)
  const $tagList = $el.find('.js-tag-list')
  const tagListUrl = $el.data('url')

  debug('url', tagListUrl)

  $.get(tagListUrl, null, 'html')
    .done(data => {
      $tagList.html(data)
    })
    .always(() => {
      $tagList.removeClass('u-is-loading')
    })
})
